module.exports = __webpack_public_path__ + "img/icons.d9c226be.svg";